import { Sidebar } from "react-pro-sidebar";
import logo from "../../assests/logo.png";
import { useEffect, useState } from "react";
import { useStores } from "../../store";
import SidebarCard from "./SidebarCard";
import Header from "./header";
import Question from "./Question";
import { Observer } from "mobx-react";
import ProgressBar from "./progressbar";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import MockTestAnalyticsPopup from "../reusble_components/MockTestAnalyticsPopup";
export default function Test() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const applicationId = queryParams.get("applicationId");
  const mocktestId = queryParams.get("mocktestId");
  const { MockStore } = useStores();
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [aptitude, setaptitude] = useState(false);
  const [view1, setvew1] = useState(false);
  const [view2, setvew2] = useState(false);
  const [view3, setvew3] = useState(false);
  const [view4, setvew4] = useState(false);
  const branch = localStorage.getItem("branch");
  const navigate = useNavigate();
  const handleNumberClick = (number) => {
    setSelectedNumber(number);
  };
  const [noOfAptitudeQuestions, setNoOfAptitudeQuestions] = useState(0);
  const [noOfReasoningQuestions, setNoOfReasoningQuestions] = useState(0);
  const [noOfVerbalQuestions, setNoOfVerbalQuestions] = useState(0);
  const [noOfTechnicalQuestions, setNoOfTechnicalQuestions] = useState(0);
  const [noOfAptitudeQuestionsAnswered, setNoOfAptitudeQuestionsAnswered] =
    useState(0);
  const [noOfReasoningQuestionsAnswered, setNoOfReasoningQuestionsAnswered] =
    useState(0);
  const [noOfVerbalQuestionsAnswered, setNoOfVerbalQuestionsAnswered] =
    useState(0);
  const [noOfTechnicalQuestionsAnswered, setNoOfTechnicalQuestionsAnswered] =
    useState(0);
  const [noOfQuestions, setNoOfQuestions] = useState(0);
  const [noOfUnansweredQuestions, setNoOfUnansweredQuestions] = useState(0);
  const [popup, setPopup] = useState(false);

  const handleCheck = () => {
    let aptitudeQuestions = 0;
    let reasoningQuestions = 0;
    let verbalQuestions = 0;
    let technicalQuestions = 0;
    let aptitudeQuestionsAnswered = 0;
    let reasoningQuestionsAnswered = 0;
    let verbalQuestionsAnswered = 0;
    let technicalQuestionsAnswered = 0;
    let questions = 0;
    let unansweredQuestions = 0;

    MockStore.question.APTITUDE.forEach((item) => {
      questions++;
      aptitudeQuestions++;
      if (item.userAns) {
        aptitudeQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    MockStore.question.REASONING.forEach((item) => {
      questions++;
      reasoningQuestions++;
      if (item.userAns) {
        reasoningQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    MockStore.question.VERBAL.forEach((item) => {
      verbalQuestions++;
      questions++;
      if (item.userAns) {
        verbalQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    MockStore.question.CORE.forEach((item) => {
      technicalQuestions++;
      questions++;
      if (item.userAns) {
        technicalQuestionsAnswered++;
      } else {
        unansweredQuestions++;
      }
    });

    setNoOfAptitudeQuestions(aptitudeQuestions);
    setNoOfReasoningQuestions(reasoningQuestions);
    setNoOfVerbalQuestions(verbalQuestions);
    setNoOfTechnicalQuestions(technicalQuestions);
    setNoOfAptitudeQuestionsAnswered(aptitudeQuestionsAnswered);
    setNoOfReasoningQuestionsAnswered(reasoningQuestionsAnswered);
    setNoOfVerbalQuestionsAnswered(verbalQuestionsAnswered);
    setNoOfTechnicalQuestionsAnswered(technicalQuestionsAnswered);
    setNoOfQuestions(questions);
    setNoOfUnansweredQuestions(unansweredQuestions);
    setPopup(true);
  };

  const Submit = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const invitationId = urlParams.get("invitationId");
    const recruiterId = urlParams.get("recruiterId");
    const applicationId = urlParams.get("applicationId");
    MockStore.getAnswer(
      applicationId ? applicationId : null,
      invitationId,
      recruiterId
    );
    MockStore.setTestOnLive(false);
    MockStore.setQuestionNumber(1);
    MockStore.setSection("APTITUDE");
    navigate("/mock-answer");
  };
  useEffect(() => {
    if (!MockStore.testOnLive) {
      navigate("/dashboard/mocktest");
    }
    // console.log("hello in test", toJS(MockStore.question));
    // console.log("hello in test", toJS(MockStore.aptitude));
    // console.log("hello in test", toJS(MockStore.reasonong));
    // console.log("hello in test", toJS(MockStore.verbals));
  }, []);
  return (
    <Observer>
      {() => {
        return (
          <div className="md:flex md:flex-row">
            {popup && (
              <MockTestAnalyticsPopup
                Apptitude={noOfAptitudeQuestions}
                Reasoning={noOfReasoningQuestions}
                Verbal={noOfVerbalQuestions}
                Tech={noOfTechnicalQuestions}
                ApptitudeAnswered={noOfAptitudeQuestionsAnswered}
                ReasoningAnswered={noOfReasoningQuestionsAnswered}
                VerbalAnswered={noOfVerbalQuestionsAnswered}
                TechAnswered={noOfTechnicalQuestionsAnswered}
                TotalAnswered={noOfQuestions - noOfUnansweredQuestions}
                TotalQuestions={noOfQuestions}
                handleCancel={() => setPopup(false)}
                handleSubmit={Submit}
              />
            )}
            <Loader loader={MockStore.loader} />
            <div className="md:h-[100vh] overflow-hidden">
              <Sidebar
                className="hidden md:block border h-full p-4 overflow-y-scroll no-scrollbar "
                style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
              >
                <img src={logo} className="py-10 w-[90%]"></img>
                {/* <div>
            {!aptitude && (
              <div className="flex flex-row justify-between p-2 bg-gray-300 items-center rounded-lg ">
                <span>Aptitude</span>{" "}
                <span className=" cursor-pointer h-max p-1 " onClick={() => setaptitude(true)} ><IoIosArrowDropright />{" "}</span>
              </div>
            )}{" "}
            {aptitude && (
              <div className="border border-primary p-2 rounded-lg">
                <span className="flex flex-row justify-between p-2 items-center" >
                  <span className="text-sm font-semibold">Aptitude</span>
                  <button onClick={()=>setaptitude(false)} className="text-primary text-sm" >view less</button>
                </span>
                <div className="grid grid-cols-5 gap-2 ">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((number) => (
                  <div
                    key={number}
                    className={`flex justify-center items-center text-sm p-1.5 border border-gray-300 rounded-full cursor-pointer ${
                      selectedNumber === number ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => handleNumberClick(number)}
                  >
                    {number}
                  </div>
                ))}
                </div>
              </div>
            )}
          </div> */}
                <div className="flex flex-col gap-2">
                  <SidebarCard
                    name="Aptitude"
                    number={MockStore?.aptitude?.length}
                  ></SidebarCard>
                  <SidebarCard
                    name="Reasoning"
                    number={MockStore?.reasonong?.length}
                  ></SidebarCard>
                  <SidebarCard
                    name="Verbal"
                    number={MockStore?.verbals?.length}
                  ></SidebarCard>
                  {/* <SidebarCard name="Programing" number="10"></SidebarCard> */}
                  <SidebarCard
                    name="Core"
                    number={MockStore?.core?.length}
                  ></SidebarCard>
                  <button
                    className="bg-primary text-white rounded-xl w-[90%] py-2"
                    onClick={() => {
                      // MockStore.getAnswer(applicationId ? applicationId : null, mocktestId ? mocktestId : null);
                      // if(MockStore.navigate){
                      //   MockStore.setQuestionNumber(1);
                      // MockStore.setSection("APTITUDE");
                      //   navigate("/mock-answer");
                      // }
                      handleCheck();
                    }}
                  >
                    <span>Submit</span>
                  </button>
                </div>
              </Sidebar>
            </div>

            <div className="md:w-[90vw] lg:w-[90vw]  w-[100%]">
              <Header
                ans={MockStore.count}
                que={localStorage.getItem("que")}
                score={(MockStore.count / localStorage.getItem("que")) * 100}
              ></Header>

              <ProgressBar
                ans={MockStore.count}
                que={localStorage.getItem("que")}
                score={(MockStore.count / localStorage.getItem("que")) * 100}
              ></ProgressBar>
              <div className="flex flex-col gap-2 md:hidden pl-7 pt-4 ">
                <SidebarCard
                  name="Aptitude"
                  number={MockStore.aptitude.length}
                ></SidebarCard>
                <SidebarCard
                  name="Reasoning"
                  number={MockStore.reasonong.length}
                ></SidebarCard>
                <SidebarCard
                  name="Verbal"
                  number={MockStore.verbals.length}
                ></SidebarCard>
                {/* <SidebarCard name="Programing" number="10"></SidebarCard> */}
                <SidebarCard
                  name="Core"
                  number={MockStore.core.length}
                ></SidebarCard>
              </div>

              {MockStore.testOnLive ? (
                <div className=" inset-0 p-5 md:p-10">
                  <Question></Question>
                </div>
              ) : (
                <div> test completed</div>
              )}

              <></>
            </div>
          </div>
        );
      }}
    </Observer>
  );
}
